import {BaseParticipatingTool, InvitationTableQuickFilter} from './invitation-table.types';

export function filterToolItems<T extends BaseParticipatingTool>(
  items: T[],
  quickFilter: InvitationTableQuickFilter<T> | undefined,
  selectedValue: string | null,
  searchQuery: string | null,
): T[] {
  if (!quickFilter) {
    return items;
  }
  const query = searchQuery?.trim().toLowerCase() ?? '';

  return items.filter(
    (item) =>
      (selectedValue === null || quickFilter.matches(item, selectedValue)) &&
      (query === '' || quickFilter.searchText(item).toLowerCase().includes(query)),
  );
}
